// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { featuredProductsStyles } from "@guestsupply/App/Components/Header/FeaturedProducts";
import { styledScrollbar, xScreen } from "@guestsupply/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

featuredProductsStyles.centeringWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        height: 300px;
        justify-content: center;
        align-items: center;
    `,
};
featuredProductsStyles.wrapper = {
    css: css`
        width: 52%;
        border-left: 1px solid ${getColor("common.border")};
        background-color: ${getColor("common.ui2")};
        padding: 16px 22px;
        height: 100%;
        max-height: ${({ headerHeight }: any) => `calc((100vh - ${headerHeight || "140px"}) * 0.8)`};
        border-radius: 0 0 4px 0;
        ${styledScrollbar(5)}
        ${xScreen("gt", "xl")} {
            width: 520px;
        }
        ${xScreen("lte", "md")} {
            width: 100%;
            max-width: initial;
            background: transparent;
            padding: 24px 0;
            border: initial;
            border-top: 1px solid ${getColor("common.border")};
            height: auto;
            max-height: initial;
        }
    `,
};
featuredProductsStyles.featuredProductsTypography = {
    as: "h6",
    css: css`
        color: ${getColor("text.main")};
        font-weight: bold;
        line-height: 17px;
    `,
};
featuredProductsStyles.featuredProductsItemsWrapper = {
    css: css`
        margin-top: 15px;
    `,
};
featuredProductsStyles.notify = {
    css: css`
        margin-bottom: 0;
        color: ${getColor("text.main")};
    `,
};
